import { Flex, Tooltip } from 'antd'

import { useFontSize } from '@eastcoal/editor/hooks/useFontSize'
import { SHORTCUTS } from '@eastcoal/editor/plugins/ShortcutsPlugin/shortcuts'

import { FontSizeSelect as CommonFontSizeSelect } from '../../../components/FontSizeSelect'

export const FontSizeSelect = () => {
  const { fontSize, setFontSize } = useFontSize()

  return (
    <Tooltip
      title={
        <Flex vertical align='center'>
          <span>字体大小</span>
          <span>{SHORTCUTS.FONT_SIZE}</span>
        </Flex>
      }
    >
      <CommonFontSizeSelect
        style={{ width: 120 }}
        value={fontSize}
        onChange={setFontSize}
      />
    </Tooltip>
  )
}
